<template lang="html">
    <div class="page" id="lessonRecords">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Lesson Records</h2>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <ul class="lessonList">
                <li
                    class="historyLesson"
                    v-for="lesson in pastLessons"
                    :key="lesson.id"
                    :class="{ noRecord: !lesson.record }"
                >
                    <router-link
                        :to="{
                            name: 'proPlayerLesson',
                            params: { id: lesson.player.id, lesson: lesson.id },
                        }"
                    >
                        <span v-if="!lesson.record">
                            {{ $date(lesson.date).format("DD MMM YYYY") }}
                            <strong>Create new lesson record</strong>
                            <img class="recordArrow" src="@/assets/arrow-plus-white.svg" />
                        </span>
                        <span v-else>
                            <b
                                ><span v-if="!lesson.title">Untitled record</span
                                ><span class="title" v-else>{{ lesson.title }}</span></b
                            >
                            {{ $date(lesson.date).format("DD MMM YYYY") }}

                            <template v-if="lesson.start != lesson.end">
                                {{ $date("2020-12-08 " + lesson.start).format("HH:mm") }} -
                                {{ $date("2020-12-08 " + lesson.end).format("HH:mm") }}
                            </template>

                            <lesson-star :lesson="lesson" />
                            <img class="recordArrow" src="@/assets/arrow-right-white.svg" />
                        </span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import LessonStar from "@/components/Player/Lessons/lesson-star";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
export default {
    name: "book",
    components: { FadeImage, XIcon, LessonStar },
    created() {
        this.getPastUpcomingLessons();
    },
    data() {
        return {
            pastLessons: [],
        };
    },
    methods: {
        getPastUpcomingLessons() {
            window.axios.get("/lessons/past-upcoming").then((response) => {
                this.pastLessons = response.data.past;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.historyLesson {
    background: white;
    border-radius: $radius;
    margin-bottom: 10px;
    padding: 17px 20px;
    position: relative;

    a {
        text-decoration: none;
        color: $green_0;
        font-weight: 200;
    }
    &.noRecord {
        background: $green_0;
        color: white;
        a {
            color: white;
        }
        strong {
            font-weight: 400;
            display: block;
            margin-top: 10px;
        }
    }
    b {
        font-weight: 400;
        margin-bottom: 10px;
        display: block;
    }
    .recordArrow {
        position: absolute;
        right: 15px;
        bottom: 20px;
        pointer-events: none;
    }
    .star {
        position: absolute;
        right: 35px;
        bottom: 14px;
        top: auto;
    }
}
.title {
    line-height: 1.5;
}
</style>
